module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAPJJREFUOE/dlCFSA0EQRd8cAoX+F8DhwBAXRXEDTDQCR6IQuUdMKmdIUCjsiv1HiMwBQs2SqRqoTXZ2CYZRO7M9r/7v7ulAtmyvgZv8rOtbUshjvm3+EjgF3jrURTeUKpxKmp0C2t7/M2BXdYGY5+IcFvC+QkqL0gaMRXr5+WMosAYWyWYOHQp8BC7PBVxJured270CxkNyuANGkt6TTdvPwGva97XctMZBycx2HBzNkxsKTPc2km5tfwDR7u+BQAVMztU2m2Nzsm8Ok6AtcNHW7a1A23fA9UFFr4md9WYladlM7Lqu5yGEp+IH3B64lPTwCVOxghX6AqpBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/cathode_gry.png
// module id = uokU
// module chunks = 2